import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";

// data

export default /*#__PURE__*/_defineComponent({
  __name: 'InputButtons',
  setup(__props) {

const opened = ref<boolean>(false);

// methods
function change() {
	opened.value = !opened.value;
}
function changeAfter() {
    setTimeout(change, 0)
}

return { __sfc: true,opened, change, changeAfter }
}

})